import { Fragment } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $downloadInquiryAttachmentStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { InquiryStatus, type GetInquiryResponse } from '@shared/api';
import { FileRow, NoData, Spinner, Text } from '@shared/widgets';

interface DocumentsProps {
  className?: string;
  inquiry: GetInquiryResponse;
}

export const Documents = (props: DocumentsProps) => {
  const downloadInquiryAttachmentStore = useUnit($downloadInquiryAttachmentStore.store);

  const { t } = useTranslation('travel');

  const noDataText = {
    [InquiryStatus.InProgress]: t('documents.noData.inProgress'),
    [InquiryStatus.Confirmed]: t('documents.noData.confirmed'),
    [InquiryStatus.Completed]: t('documents.noData.completed'),
    [InquiryStatus.Cancelled]: t('documents.noData.cancelled'),
  };
  const showDocuments = props.inquiry.status !== InquiryStatus.Cancelled && props.inquiry.attachments.length > 0;
  return (
    <section
      className={cn(
        'flex h-fit flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Spinner show={downloadInquiryAttachmentStore.loading} position />
      <Text tag='h2' weight='semibold' size='2xl'>
        {t('documents.title')}
      </Text>
      {showDocuments ? (
        <div className='flex flex-col gap-4'>
          {props.inquiry.attachments.map((attachment) => (
            <Fragment key={attachment.id}>
              <FileRow
                file={attachment}
                onDownload={() =>
                  $downloadInquiryAttachmentStore.events.downloadInquiryAttachment({ attachmentId: attachment.id, name: attachment.fileName })
                }
              />
              <hr className={cn('last:hidden', PaletteUtils.isVcfcPalette && 'text-gray-black')} />
            </Fragment>
          ))}
        </div>
      ) : (
        <NoData className='justify-start p-0' color='gray' text={noDataText[props.inquiry.status]} />
      )}
    </section>
  );
};
